import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';

export default class CustomerProfile {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.address = args.address || '';
		this.bonusPointBalance = args.bonusPointBalance || 0;
		this.chainId = args.chainId || 0;
		this.createdDate = moment(args.createdDate || '');
		this.customerCategoryId = args.customerCategoryId || '';
		this.customerCategoryName = args.customerCategoryName || '';
		this.customerId = args.customerId || '';
		this.customerProgramId = args.customerProgramId || 0;
		this.email = args.email || '';
		this.favouriteEmployee = (args.favouriteEmployee || '').trim();
		this.favouriteSiteId = args.favouriteSiteId || 0;
		this.favouriteTreatments = args.favouriteTreatments || [];
		this.firstName = args.firstName || '';
		this.hasBookingProfile = !!args.hasBookingProfile;
		this.isInCustomerProgram = !!args.isInCustomerProgram;
		this.lastName = args.lastName || '';
		this.lastVisitDate = moment(args.lastVisitDate || '');
		this.membershipProfileId = args.membershipProfileId || '';
		this.mobilePhoneNumber = args.mobilePhoneNumber || '';
		this.nextVisitDate = moment(args.nextVisitDate || '');
		this.numberOfVisits = args.numberOfVisits || 0;
		this.postalArea = args.postalArea || '';
		this.postalCode = args.postalCode || '';
		this.receiveMarketing = args.receiveMarketing || 0;
		this.sex = args.sex || 0;
		this.siteId = args.siteId || 0;
	}
}
